import React, { useState } from 'react';
import UseStore from '../store/store'

export default function MultipleChoiceQ({ mcqNumber, mcqOptions, triggerNextStep}){
    const [mcqAnswers, setMcqAnswers] = useState([])
    const [isnotchecked, setIsCheckedCheckBox] = useState(true)
    const [disableCheckBox, setDisableCheckBox] = useState(false)
    const [isNone, setIsNone] = useState(false)
    const {mcq_1, setMcq_1, setMcq_2, setMcq_3} = UseStore()

    function handleSubmit(e){
        let answers
        if(isNone === true){
            answers = []
        } else {
            answers = [...mcqAnswers]
        }
        if(mcqNumber === 1){
            setMcq_1(answers)
        }
        if(mcqNumber === 2){
            setMcq_2(answers)
        }
        if(mcqNumber === 3){
            setMcq_3(answers)
        }
        setDisableCheckBox(true)
        triggerNextStep()
        e.preventDefault()
    }

    function ToggleCheckBox(e){
        const answers = [...mcqAnswers]
        const index = answers.indexOf(e.target.value)
        if(index > -1){
            answers.splice(index, 1)
        } else{
            answers.push(e.target.value)
        }
        setMcqAnswers([...answers])
    }

    function NoneOfTheAbove(e) {
        setIsNone(!isNone);
        setIsCheckedCheckBox(!isNone); // Update the isChecked state to the opposite of isNone

        // Uncheck all the checkboxes if "None of the Above" is selected
        const answers = [];
        setMcqAnswers(answers);
    }
    
    return(
        <div className="mcqComponent">
            <form onSubmit={e => handleSubmit(e)}>
                {
                    mcqOptions.map((option, i) =>{
                        return(
                            <div key={i}>
                                <label>
                                    <input disabled={disableCheckBox || isNone} type="checkbox" onChange={ToggleCheckBox} value={option} checked={mcqAnswers.includes(option)} />
                                    {option}
                                </label>
                                <br />
                            </div>
                        )
                    })
                }
                <label>
                    <input disabled={disableCheckBox} type="checkbox" onChange={NoneOfTheAbove} id="None_of_the_Above" checked={isNone} />
                    None of the Above
                </label><br /><br /><br />
                <input disabled={disableCheckBox} className={`btn-submit ${disableCheckBox?"disabled": ""}`} type="submit" />
            </form>
        </div>
    )
}